export const MY_UID = 'MY_UID'
export const SEARCH_HISTORY = 'SEARCH_HISTORY'
